import { render } from "./ExamList.vue?vue&type=template&id=0a64b260"
import script from "./ExamList.vue?vue&type=script&lang=js"
export * from "./ExamList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/admin/dev/claire/web/orca-analytics.web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__